import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ThemePicker from "./ThemePicker";
import { apiGet } from "../api/client";
import { streamPagePath } from "../pages/stream/StreamPage";
import "../styles.css";

const NAV_LINKS = [
  { index: "01", label: "HOME", to: "/", match: (path) => path === "/" },
  { index: "02", label: "ABOUT", to: "/about", match: (path) => path === "/about" },
  {
    index: "03",
    label: "STREAM",
    to: "/stream",
    match: (path) => path === "/stream" || path.startsWith("/stream-"),
    dropdown: true,
  },
  { index: "04", label: "REVIEWS", to: "/reviews", match: (path) => path === "/reviews" || path === "/games" },
  { index: "05", label: "VIDEOS", to: "/videos", match: (path) => path === "/videos" },
  { index: "06", label: "TOOLS", to: "/tools", match: (path) => path === "/tools" || path === "/shop" },
  { index: "07", label: "CONTACT", to: "/contact", match: (path) => path === "/contact" },
  { index: "08", label: "STREAMERS", to: "/streamers", match: (path) => path === "/streamers", special: "amber" },
];

export default function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [streamDropdownOpen, setStreamDropdownOpen] = useState(false);
  const [streamNavPages, setStreamNavPages] = useState([]);

  useEffect(() => {
    apiGet('/stream-pages')
      .then((pages) => {
        const navPages = pages
          .filter((p) => p.showInNav)
          .sort((a, b) => (b.sortOrder || 0) - (a.sortOrder || 0));
        setStreamNavPages(navPages);
      })
      .catch(console.error);
  }, []);

  const handleToggle = () => setMenuOpen((open) => !open);
  const handleLinkClick = () => {
    setMenuOpen(false);
    setStreamDropdownOpen(false);
  };

  const renderNavItem = (item) => {
    const isActive = item.match(location.pathname);
    const classNames = [
      item.special === "amber" ? "nav-amber-link" : "",
      isActive ? "active" : "",
    ]
      .filter(Boolean)
      .join(" ");

    if (item.dropdown) {
      return (
        <li
          key={item.to}
          className={`animus-nav-dropdown${menuOpen && streamDropdownOpen ? " is-open" : ""}`}
        >
          <Link
            to={item.to}
            className={classNames}
            onClick={handleLinkClick}
            aria-haspopup="true"
            aria-expanded={menuOpen ? streamDropdownOpen : undefined}
          >
            <span className="nav-index">{item.index}</span>
            <span className="nav-sep">{'//'}</span>
            <span className="nav-label">{item.label}</span>
            <i className="fas fa-chevron-down animus-nav-dropdown-icon" aria-hidden="true" />
          </Link>
          <ul className="animus-nav-submenu">
            {streamNavPages.map((page) => (
              <li key={page.slug}>
                <Link
                  to={streamPagePath(page.slug)}
                  className={location.pathname === streamPagePath(page.slug) ? "active" : ""}
                  onClick={handleLinkClick}
                >
                  {page.navLabel || page.title}
                </Link>
              </li>
            ))}
          </ul>
          {menuOpen && (
            <button
              type="button"
              className="animus-nav-mobile-toggle"
              onClick={() => setStreamDropdownOpen((open) => !open)}
              aria-expanded={streamDropdownOpen}
            >
              {streamDropdownOpen ? "Hide stream pages" : "Show stream pages"}
            </button>
          )}
        </li>
      );
    }

    return (
      <li key={item.to}>
        <Link
          to={item.to}
          className={classNames}
          onClick={handleLinkClick}
        >
          <span className="nav-index">{item.index}</span>
          <span className="nav-sep">{'//'}</span>
          <span className="nav-label">{item.label}</span>
        </Link>
      </li>
    );
  };

  return (
    <header className="animus-header">
      <div className="container animus-header__main">
        <div className="logo">
          <Link to="/" onClick={handleLinkClick}>ZEMAXI</Link>
        </div>
        <nav className={menuOpen ? "open" : ""} aria-label="Main navigation">
          <ul>
            {NAV_LINKS.map(renderNavItem)}
          </ul>
        </nav>
        <ThemePicker />
        <button
          type="button"
          className={`menu-toggle${menuOpen ? " open" : ""}`}
          onClick={handleToggle}
          aria-expanded={menuOpen}
          aria-label="Toggle menu"
        >
          <i className="fas fa-bars" aria-hidden="true"></i>
        </button>
      </div>
    </header>
  );
}
